export * from 'SourceComponent/ProductActions/ProductActions.config';
export const CATEGORY_NAME_SHOES = 'Shoes';
export const CATEGORY_NAME_SHOES_ARABIC = 'الأحذية';
export const DEFAULT_MAX_PRODUCTS = 10;
